import { AtdSettingsPresentation } from "./AtdSettings.pres";
import { useAtdPreferencesContext } from "./AtdTheme.context";

export interface AtdSettingsProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AtdSettings = ({ open, onOpenChange }: AtdSettingsProps) => {
  const {
    theme,
    setTheme,
    navPosition,
    setNavPosition,
    widgetGroupLinePosition,
    setWidgetGroupLinePosition,
  } = useAtdPreferencesContext();

  return (
    <AtdSettingsPresentation
      open={open}
      theme={theme}
      navPosition={navPosition}
      widgetGroupLinePosition={widgetGroupLinePosition}
      onOpenChange={onOpenChange}
      onDarkModeChange={(checked) => setTheme(checked ? "dark" : "light")}
      onNavPositionChange={setNavPosition}
      onWidgetGroupLinePositionChange={setWidgetGroupLinePosition}
    />
  );
};
